(function () {
  "use strict";

  var config = null;
  var skipDuplicates = true;
  var linkedFirst = false;
  var linkedData = [];

  function readConfig() {
    var dataEl = document.getElementById("linkedColorSwatchesData");
    if (!dataEl) return false;

    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return false;
    }

    if (!config || !config.products || !config.products.length) return false;

    skipDuplicates = config.skip_duplicates !== false;
    linkedFirst = config.linked_first === true;
    linkedData = config.products;
    return true;
  }

  // Read Swatch King colors from the hidden "Linked Product" section
  function getSwatchKingColorsFromHiddenSection() {
    var colorMap = {};
    var hiddenSection = document.querySelector(".linkedprod variant-swatch-king");
    if (!hiddenSection) return colorMap;

    var items = hiddenSection.querySelectorAll(
      '[option-name="Color"] .swatch-view-item, [option-name="color"] .swatch-view-item'
    );
    items.forEach(function (item) {
      var name = item.getAttribute("orig-value");
      var starImg = item.querySelector(".star-set-image");
      if (!name || !starImg) return;

      var cs = window.getComputedStyle(starImg);
      colorMap[name.toLowerCase()] = {
        backgroundColor: cs.backgroundColor,
        backgroundImage: cs.backgroundImage
      };
    });

    return colorMap;
  }

  // Returns true when the hidden .linkedprod variant-swatch-king has rendered
  // its color option items AND at least one .star-set-image has a resolved
  // background-color or background-image. If hidden section doesn't exist,
  // returns true (no waiting needed; fallback to colorInfo.image URL).
  function isHiddenSectionReady() {
    var hidden = document.querySelector(".linkedprod variant-swatch-king");
    if (!hidden) return true;

    var items = hidden.querySelectorAll(
      '[option-name="Color"] .swatch-view-item, [option-name="color"] .swatch-view-item'
    );
    if (!items.length) return false;

    for (var i = 0; i < items.length; i++) {
      var starImg = items[i].querySelector(".star-set-image");
      if (!starImg) continue;
      var cs = window.getComputedStyle(starImg);
      var hasBgImage = cs.backgroundImage && cs.backgroundImage !== "none";
      var hasBgColor = cs.backgroundColor &&
        cs.backgroundColor !== "rgba(0, 0, 0, 0)" &&
        cs.backgroundColor !== "transparent";
      if (hasBgImage || hasBgColor) return true;
    }
    return false;
  }

  function findSwatchContainers() {
    var containers = [];
    var allSK = document.querySelectorAll("variant-swatch-king");
    for (var i = 0; i < allSK.length; i++) {
      if (allSK[i].closest(".linkedprod")) continue;

      var swatchOption =
        allSK[i].querySelector('[option-name="Color"] ul.swatch-view') ||
        allSK[i].querySelector('[option-name="color"] ul.swatch-view');
      if (swatchOption) containers.push(swatchOption);
    }
    return containers;
  }

  function applySwatchStyle(starImage, colorKey, colorMap, fallbackImage) {
    // 1. Try Swatch King computed styles (from hidden section)
    var skColor = colorMap[colorKey];
    if (skColor) {
      if (skColor.backgroundImage && skColor.backgroundImage !== "none") {
        starImage.style.backgroundImage = skColor.backgroundImage;
        return;
      }
      if (skColor.backgroundColor && skColor.backgroundColor !== "rgba(0, 0, 0, 0)" && skColor.backgroundColor !== "transparent") {
        starImage.style.backgroundColor = skColor.backgroundColor;
        return;
      }
    }

    // 2. Try theme swatch settings
    var themeImageSwatches = (window.MinimogSettings && window.MinimogSettings._imageSwatches) || [];
    var themeColorSwatches = (window.MinimogSettings && window.MinimogSettings._colorSwatches) || [];
    var imgSwatch = themeImageSwatches.find
      ? themeImageSwatches.find(function (s) { return s.key === colorKey; })
      : null;
    var clrSwatch = themeColorSwatches.find
      ? themeColorSwatches.find(function (s) { return s.key === colorKey; })
      : null;

    if (imgSwatch && imgSwatch.value) {
      starImage.style.backgroundImage = "url(" + imgSwatch.value + ")";
      return;
    }
    if (clrSwatch && clrSwatch.value) {
      starImage.style.backgroundColor = clrSwatch.value;
      return;
    }

    // 3. Fallback: variant featured image
    if (fallbackImage) {
      starImage.style.backgroundImage = "url(" + fallbackImage + ")";
    }
  }

  function createLinkedSwatch(colorInfo, colorMap, linkedProduct) {
    var colorKey = colorInfo.value.toLowerCase();

    var li = document.createElement("li");
    li.className = "swatch-view-item swatch-view-item--linked";
    li.setAttribute("orig-value", colorInfo.value);
    li.setAttribute("aria-label", colorInfo.value);
    li.setAttribute("role", "link");
    li.setAttribute("tabindex", "0");

    var wrapper = document.createElement("div");
    wrapper.className = "swatch-image-wrapper";

    var swatch = document.createElement("div");
    swatch.className = "swatch-image swatch-selector swatch-allow-animation swatch-linked";
    swatch.setAttribute("type", "image");
    swatch.setAttribute("orig-value", colorInfo.value);
    swatch.setAttribute("data-value", colorInfo.value);
    swatch.setAttribute("swatch-option", "option1");

    var starImage = document.createElement("div");
    starImage.className = "star-set-image";
    starImage.setAttribute("swatch-inside", "true");

    applySwatchStyle(starImage, colorKey, colorMap, colorInfo.image);

    if (!colorInfo.available) {
      li.classList.add("swatch-view-item--soldout");
      // Swatch King's strike-through CSS keys on this class; add directly so
      // OOS visual renders without waiting for refreshSwatchOOSState pass.
      li.classList.add("swatch-item-unavailable");
    }

    swatch.appendChild(starImage);

    var textEl = document.createElement("div");
    textEl.className = "swatch-img-text swatch-img-text-hidden";
    textEl.setAttribute("swatch-inside", "true");

    wrapper.appendChild(swatch);
    wrapper.appendChild(textEl);
    li.appendChild(wrapper);

    li.style.cursor = "pointer";

    // Prefetch on hover
    var handle = linkedProduct.product_handle;
    li.addEventListener("mouseenter", function () {
      if (li._prefetched) return;
      li._prefetched = true;

      // Prefetch the full page URL
      var link = document.createElement("link");
      link.rel = "prefetch";
      link.href = colorInfo.url;
      document.head.appendChild(link);

      // Also prefetch section for AJAX swap
      var mp = document.querySelector(".m-main-product");
      if (mp && mp.dataset.sectionId && handle) {
        var sectionLink = document.createElement("link");
        sectionLink.rel = "prefetch";
        sectionLink.href = "/products/" + handle + "?section_id=" + mp.dataset.sectionId;
        document.head.appendChild(sectionLink);
      }
    });

    li.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (handle && window.LinkedProductSwap) {
        window.LinkedProductSwap.swap(handle, colorInfo.url, colorInfo.value);
      } else {
        navigateToLinked(colorInfo.url);
      }
    });

    li.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (handle && window.LinkedProductSwap) {
          window.LinkedProductSwap.swap(handle, colorInfo.url, colorInfo.value);
        } else {
          navigateToLinked(colorInfo.url);
        }
      }
    });

    return li;
  }

  function navigateToLinked(url) {
    var mainProduct = document.querySelector(".m-main-product");
    if (mainProduct) {
      mainProduct.style.opacity = "0.5";
      mainProduct.style.pointerEvents = "none";
    }
    window.location.href = url;
  }

  function injectSwatches() {
    var containers = findSwatchContainers();
    if (!containers.length) return false;

    // Wait for hidden Swatch King section to populate computed CSS
    // (avoids falling back to image URL when colors are actually configured)
    if (!isHiddenSectionReady()) return false;

    var colorMap = getSwatchKingColorsFromHiddenSection();
    var injectedAny = false;

    containers.forEach(function (swatchOption) {
      // Skip containers that already have linked swatches injected
      if (swatchOption.querySelector(".swatch-view-item--linked")) {
        injectedAny = true;
        return;
      }

      var existingValues = [];
      swatchOption.querySelectorAll(".swatch-view-item").forEach(function (li) {
        var val = li.getAttribute("orig-value");
        if (val) existingValues.push(val.toLowerCase());
      });

      var fragment = linkedFirst ? document.createDocumentFragment() : null;

      linkedData.forEach(function (linked) {
        linked.colors.forEach(function (colorInfo) {
          var colorKey = colorInfo.value.toLowerCase();
          var isDuplicate = existingValues.indexOf(colorKey) !== -1;

          if (isDuplicate && skipDuplicates) return;

          // Each container needs its own cloned swatch element
          var li = createLinkedSwatch(colorInfo, colorMap, linked);

          if (isDuplicate) {
            li.classList.add("swatch-view-item--duplicate");
          }

          if (linkedFirst) {
            fragment.appendChild(li);
          } else {
            swatchOption.appendChild(li);
          }
        });
      });

      if (linkedFirst && fragment.childNodes.length > 0) {
        swatchOption.insertBefore(fragment, swatchOption.firstChild);
      }

      injectedAny = true;
    });

    return injectedAny;
  }

  function init() {
    if (!readConfig()) return;

    if (!injectSwatches()) {
      var observer = new MutationObserver(function (mutations, obs) {
        if (injectSwatches()) {
          obs.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  }

  function reinit() {
    // Re-read config from (potentially new) DOM
    if (!readConfig()) return;

    // Wait for Swatch King to render, then inject
    if (!injectSwatches()) {
      var observer = new MutationObserver(function (mutations, obs) {
        if (injectSwatches()) {
          obs.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  }

  // Expose globally for swap orchestrator
  window.LinkedColorSwatches = {
    init: init,
    reinit: reinit
  };

  // Initial run
  init();
})();
